import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';

const TemplateCreateLetterInfo = ({letterData}) => {
	const { dict } = useSelector((state) => state.app);
	const { categoriesDict, recipientsDict } = useSelector((state) => state.data);

	const getDateSpan = useCallback((dateString) => {
		if (!dateString || dateString.length < 1) return '';
		return (
			<span style={ { whiteSpace: 'nowrap' } }>
				{dateString.replace('T', ', ').replaceAll('-', '.')}
			</span>
		);
	}, []);
	return (
		<section className='letter__info'>
			{letterData && (
				<div className='letter__info--inner'>
					<div className='letter__info--bar'>
						{ letterData.date && (
							<div className='letter__info--item'>
								{dict.letter.info.date}
								{getDateSpan(letterData.date)}
							</div>
						)}						
						{letterData.author && (
							<div className='letter__info--item'>
								{dict.letter.info.author}<span>{`${letterData.author.forename} ${letterData.author.surname}`}</span>
							</div>
						)}
						<div className='letter__info--item'>
							{dict.letter.info.department}<span>{letterData.department.name}</span>
						</div>
						<div className='letter__info--item'>
							{dict.letter.info.recipient}<span>{recipientsDict[letterData.recipient]}</span>
						</div>
						{ letterData.category && (
							<div className='letter__info--item'>
								{dict.letter.categories.category}: 
								<span> {categoriesDict[letterData.category.code]}</span>
							</div>
						)}
					</div>
					<div className='letter__info--bar right'>
						<div className='letter__info--item'>
							{dict.letter.info.initiator}<span>{`${letterData.owner.forename} ${letterData.owner.surname}, ${letterData.owner.email}`}</span>
						</div>
						<div className='letter__info--item'>
							{dict.letter.info.addDate}
							{getDateSpan(letterData.createdOn)}
						</div>
						<div className='letter__info--item'>
							{dict.letter.info.editDate}{getDateSpan(letterData.modifiedOn)}
						</div>
					</div>
				</div>
			)}
		</section>
	);
};
export default React.memo(TemplateCreateLetterInfo);